import { z } from 'zod'

export const signupSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  companyName: z.string().min(1, 'Company name is required'),
  email: z.string().email('Invalid email address'),
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .max(20, 'Invalid phone number')
    .regex(/^\+?[\d\s()-]{7,20}$/, 'Invalid phone number'),
})

export type SignupSchemaType = z.infer<typeof signupSchema>

export const verifyOtpSchema = z.object({
  verificationCode: z.string().length(6, 'OTP must be 6 digits'),
})

export type VerifyOtpSchemaType = z.infer<typeof verifyOtpSchema>
